var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegistraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.3 8.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#c192f3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 4.15,
    cy: 4.15,
    r: 4.15
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.22,6.08c0,.09-.07,.16-.16,.16H1.75c-.09,0-.16-.07-.16-.16v-.02c.09-1.2,1.09-2.14,2.32-2.14s2.22,.94,2.32,2.14v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.88,2.59c0,.54-.44,.97-.98,.97-.54,0-.98-.44-.97-.98,0-.54,.44-.98,.98-.97,.54,0,.97,.44,.97,.98Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 5.88,
    cy: 3.95,
    r: 1.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.88,5.1c-.63,0-1.15-.52-1.15-1.15s.52-1.15,1.15-1.15,1.15,.52,1.15,1.15-.52,1.15-1.15,1.15Zm0-2.16c-.56,0-1.01,.45-1.01,1.01s.46,1.01,1.01,1.01,1.01-.46,1.01-1.01-.45-1.01-1.01-1.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.46,3.78h-.44v-.44c0-.06-.05-.1-.1-.1s-.1,.05-.1,.1v.44h-.44c-.06,0-.1,.05-.1,.1s.05,.1,.1,.1h.44v.44c0,.06,.05,.1,.1,.1s.1-.05,.1-.1v-.44h.44c.06,0,.1-.05,.1-.1s-.05-.1-.1-.1Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistraIcon);
export default __webpack_public_path__ + "static/media/registra_icon.ff16003e6338adcea90fbd26548dd9f7.svg";
export { ForwardRef as ReactComponent };